import { render, staticRenderFns } from "./PredefinedStatusesList.vue?vue&type=template&id=be8634c6&scoped=true"
import script from "./PredefinedStatusesList.vue?vue&type=script&lang=js"
export * from "./PredefinedStatusesList.vue?vue&type=script&lang=js"
import style0 from "./PredefinedStatusesList.vue?vue&type=style&index=0&id=be8634c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8634c6",
  null
  
)

export default component.exports